import { HttpHandler } from 'msw'

import { getAllMachineRelations } from './getAllMachineRelations'

export const machineRelations: HttpHandler[] = [getAllMachineRelations]
